<dx-data-grid
    bds-grid
    id="bdsReportGrid"
    [dataSource]="gridSource"
    height="90vh"
    minHeight="200px"
    dataRowTemplate="dataRowTemplateName"
    [allowColumnResizing]="false"
>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
    <dxi-column dataField="car_init" caption="Car ID"></dxi-column>
    <dxi-column dataField="ship_date_time" caption="Ship Date" dataType="date"></dxi-column>
    <dxi-column dataField="dest_arr_date_time" caption="Arrv Date" dataType="date"></dxi-column>
    <dxi-column dataField="rqst_dlv_date_time" caption="Rqst Date" dataType="date"></dxi-column>
    <dxi-column dataField="cust_name" caption="Consignee"></dxi-column>
    <dxi-column dataField="origin_city" caption="Origin"></dxi-column>
    <dxi-column dataField="dest_city" caption="Destination"></dxi-column>
    <dxi-column dataField="fleet_id" caption="Fleet"></dxi-column>
    <dxi-column dataField="business_group" caption="Bus. Grp"></dxi-column>
    <ng-container *dxTemplate="let item of 'dataRowTemplateName'">
        <tr class="main-row">
            <td>{{ item.data.car_init }} {{ item.data.car_no }}</td>
            <td>{{ item.data.ship_date_time | date : 'MM/dd/yy' }}</td>
            <td>{{ item.data.dest_arr_date_time | date : 'MM/dd/yy' }}</td>
            <td>{{ item.data.rqst_dlv_date_time | date : 'MM/dd/yy' }}</td>
            <td>{{ item.data.cust_no }} {{ item.data.cust_name }}</td>
            <td>{{ item.data.origin_city }} {{ item.data.origin_state }}</td>
            <td>{{ item.data.dest_city }} {{ item.data.dest_state }}</td>
            <td>{{ item.data.fleet_id }}</td>
            <td>{{ item.data.business_group }}</td>
        </tr>
        <tr class="second-row">
            <td></td>
            <td colspan="4">
                <div>
                    <span><b>Route Dscr: </b></span>{{ item.data.route_dscr }}
                </div>
            </td>
            <td colspan="4">
                <div>
                    <span><b>Dlv Carrier: </b></span>{{ item.data.dlv_road }}
                </div>
            </td>
        </tr>
    </ng-container>
</dx-data-grid>
